import {
  SIDEBAR_ITEM_BUTTON_CLASS_NAME,
  SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME,
} from '../../constants/listItemButton';

const sidebarItemButton = ({ theme }) => ({
  minHeight: 48,
  borderTopLeftRadius: theme.spacing(0.25),
  borderBottomLeftRadius: theme.spacing(0.25),
  paddingLeft: theme.spacing(1),
  color: theme.palette.gray.A600,
  fontWeight: 500,
});

const sidebarItemButtonActive = ({ theme }) => ({
  color: theme.palette.text.A700,
  backgroundColor: theme.palette.secondary.A200,
  borderRight: '4px solid',
  borderColor: theme.palette.secondary.A400,
  '&:hover': {
    backgroundColor: theme.palette.secondary.A200,
  },
  '& .MuiListItemText-primary': {
    fontWeight: 600,
  },
});

const MuiListItemButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${SIDEBAR_ITEM_BUTTON_CLASS_NAME}`]: sidebarItemButton({ theme }),
      [`&.${SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME}`]: {
        ...sidebarItemButton({ theme }),
        ...sidebarItemButtonActive({ theme }),
      },
    }),
  },
};

export default MuiListItemButton;
